"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const react_1 = __importStar(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("../utils"); // Utility function for conditional classNames
// Define the toast variants with Tailwind classes
const toastVariants = (0, class_variance_authority_1.cva)("font-bold rounded-md shadow-md py-[14px] px-4 gap-4 flex items-center z-50", // Shared base classes
{
    variants: {
        position: {
            top: "fixed top-4 left-1/2 -translate-x-1/2",
            bottom: "fixed bottom-4 left-1/2 -translate-x-1/2",
            topLeft: "fixed top-4 left-4",
            topRight: "fixed top-4 right-4",
            bottomLeft: "fixed bottom-4 left-4",
            bottomRight: "fixed bottom-4 right-4",
        },
        bgColor: {
            success: "bg-primary100 text-brandBlack",
            error: "bg-[#e16645] text-brandWhite",
            info: "bg-blue-500 text-brandWhite",
            warning: "bg-[#25a9ef] text-brandWhite"
        },
    },
    defaultVariants: {
        position: "top", // Default position
        bgColor: "info", // Default background color
    },
});
const Toast = ({ position, bgColor, message, autoCloseDuration = 3000, // Default duration is 3 seconds
onClose, className, closeButton = react_1.default.createElement("span", { className: "demo-icon icon-close text-brandBlack text-[14px]" }), }) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            onClose();
        }, autoCloseDuration);
        return () => clearTimeout(timer);
    }, [autoCloseDuration, onClose]);
    if (!isVisible)
        return null;
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(toastVariants({ position, bgColor }), className), role: "alert", "aria-live": "polite", "aria-atomic": "true" },
        message && react_1.default.createElement("div", { className: "flex-1" }, message),
        react_1.default.cloneElement(closeButton, {
            onClick: () => {
                setIsVisible(false);
                onClose();
            },
        })));
};
exports.Toast = Toast;
